module.exports = __webpack_public_path__ + "static/msab-37f3267a43166e60e32a7b86fb3fba52.png";